type Props = {
	titleChildren: React.ReactNode;
	children: React.ReactNode;
};

export const PrintSectionLayout = ({ titleChildren, children }: Props) => {
	return (
		<div className="w-full space-y-2">
			{titleChildren}

			{children}
		</div>
	);
};
